var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SimpleTable,{attrs:{"flat":true,"title":"Eventos Asistidos","subtitle":"Eventos a los que ha asistido","columns":_setup.columns,"data":_vm.eventos,"empty-text":"No hay eventos asistidos","default-col-width":_vm.defaultColWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }